import { toast } from "sonner";
import { api } from "@/lib/api";
import { createFieldActions, fieldActionMessage, isConflictRefusal, photoRefusalMessage, rereadsAfterEvidenceRefusal } from "@/lib/appointment-field-actions";

export const appointmentFieldActions = createFieldActions(api.appointments);

export async function reportFieldActionRefusal(error: unknown, fallback: string, reReadAfterConflict: () => unknown) {
  console.error(`${fallback}:`, error);
  toast.error(fieldActionMessage(error, fallback));
  if (!isConflictRefusal(error)) return;
  try {
    await reReadAfterConflict();
  } catch (readError) {
    console.error("Failed to re-read the appointment:", readError);
  }
}

async function reReadAfterEvidenceRefusal(error: unknown, reRead: () => unknown) {
  if (!rereadsAfterEvidenceRefusal(error)) return;
  try {
    await reRead();
  } catch (readError) {
    console.error("Failed to re-read the appointment:", readError);
  }
}

export async function reportPhotoRefusal(error: unknown, reReadAfterRefusal: () => unknown) {
  console.error("Failed to upload photo:", error);
  toast.error(photoRefusalMessage(error, "Failed to upload photo"));
  await reReadAfterEvidenceRefusal(error, reReadAfterRefusal);
}

export async function reportTickRefusal(error: unknown, reReadAfterRefusal: () => unknown) {
  console.error("Failed to update task status:", error);
  toast.error(fieldActionMessage(error, "Failed to update task status"));
  await reReadAfterEvidenceRefusal(error, reReadAfterRefusal);
}

export function reportUploadFailure(error: unknown): null {
  console.error("Failed to upload photo:", error);
  toast.error(error instanceof Error && error.message ? error.message : "Failed to upload photo");
  return null;
}
